<template>
  <div ref="body">
    <custom-header active="global" :subActive="current"></custom-header>

    <div class="content-container">
      
      <!-- <div class="flex text-center">
        <div :class="['tab', current == 'traffic' ? 'active' : '',]" @click="tabChange('traffic')">
          <div class="tab-icon">
            <img src="https://szcwcdn.szcreativeweek.com/f1h0bvkatg1646989078932.jpg" alt="" class="fill">
          </div>
          <div class="text-bold">便捷交通</div>
        </div>
        <div :class="['tab', current == 'plane' ? 'active' : '',]" @click="tabChange('plane')">
          <div class="tab-icon">
            <img src="https://szcwcdn.szcreativeweek.com/91vks1g5v81646989122394.jpg" alt="" class="fill">
          </div>
          <div class="text-bold">特惠机票</div>
        </div>
        <div :class="['tab', current == 'hotel' ? 'active' : '',]" @click="tabChange('hotel')">
          <div class="tab-icon">
            <img src="https://szcwcdn.szcreativeweek.com/6cbp48730g1646989111979.jpg" alt="" class="fill">
          </div>
          <div class="text-bold">超值酒店</div>
        </div>
      </div> -->
<!--       
      <img src="https://szcwcdn.szcreativeweek.com/cn/img/traffic/bus.png" alt="便捷交通" class="title-img"> -->
      <div ref="traffic" class="section">
        
        <div class="tips text-bold">温馨提醒: 由于展会现场交通相对拥堵且停车位有限，主办方建议大家乘坐公共交通绿色出行。</div>

        <div class="row text-bold">1、地铁</div>
        <div class="end-row">1号线、4号线会展中心站(D出口)过红绿灯直走200米，即可抵达展馆</div>
        
        <div class="row text-bold">2、出租车</div>
        <div class="end-row">请将目的地设置为：深圳福田会展中心（福华三路111号）下客区北2门</div>
        
        <div class="row text-bold">3、城际交通</div>
        <div>● 高铁</div>
        <div>深圳北站→（4 号线 / 福田口岸方向）→会展中心站 (1号线、4号线 D出口)</div>
        <div>罗湖站（1号线 / 机场东方向）→会展中心站（1号线、4号线 D出口）</div>
  
        <div>● 机场</div>
        <div class="end-row">机场东站（11号线/福田方向）→车公庙站（1号线/罗湖方向）→会展中心站（1号线、4号线 D出口）</div> 
      
        <div class="row text-bold">4、公交路线</div>
        <div class="end-row">【站点：会展中心站】：109路 /15路 /235路 /371路 /374路 /375路/379路 /50 路 /64路 /71路 /76 路区间 /80路 / 机场9线/ 高峰专车19路 / 高峰专线车23路 /76路 / 高峰快巴8路</div>
        <div class="end-row">【站点：会展中心南站】：229路 /337路 /338路 /353路 /369路 /382路 /J1路</div>
        
        <div class="end-row"></div>

        <div class="row text-bold">5、自驾</div>
        <div>导航至：深圳福田会展中心（福华三路111号）</div>
        <div>● 地面停车路线：</div>
        <div>※会展中心地下停车场 | 收费：8:00-20:00 间，前1小时15元,之后 1.5元/半小时；20:00-次日8:00期间1元/小时；</div>
        
        <div class="end-row"></div>
        <div class="end-row"></div>

        <div class="row text-bold">温馨提醒：</div>
        <div class="end-row">
          如果您的车不是粤B车牌，请自行登陆“深圳交警网”申请临时通行证
        </div> 
 
      </div>
      
      <!-- <img src="https://szcwcdn.szcreativeweek.com/cn/img/traffic/plane.png" alt="特惠机票" class="title-img">
      <div ref="plane" class="section">

        <div class="row text-bold">展会专属增值服务</div>
        <div class="end-row">第 42 届深圳国际家具展暨深圳家居设计周 与 深圳航空达成战略合作，为来自全国的参展商及专业买家提供机票预订等服务，更好地为大家节省展会期间出行开支，专享深航、携程商旅会展合作优惠。</div>
        
        <div class="row text-bold">优惠对象:</div>
        <div class="end-row">2027年所有第42届深圳国际家具展暨深圳家居设计周【展商】和【观众】</div>
        
        <div>
          <div class="row text-bold text-center"><h2 class="text-bold">深航专线</h2></div>
          <div class="end-row flex justify-center">
            <img src="https://exhoss39.szcreativeweek.com/applet/img/plane/sh-logo.png" alt="" class="t-log1">
          </div>
          
          <div class="end-row text-center"># 深圳航空 - 官方指定战略航司 #</div>
          <div class="row text-bold">一、展期优惠政策: </div>
          
          <div class="row text-bold">1 、适用时间：</div> 
          <div class="row">销售时间：即日起-2025年3月24日</div>
          <div class="end-row">乘机时间：2025年3月11日--2025年3月24日</div>
          
          <div class="row text-bold">2、适用航线及订票折扣</div>
          <table class="table" border="0" cellspacing="0" cellpadding="0" style="width: 100%; margin: 0 auto; text-align: center; vertical-align: middle; line-height: 2em;">
            <tr style="background-color: #C7DAF1; line-height: 3em;">
              <th>适用航线</th>
              <th>适用舱位</th>
              <th>票面减幅</th>
              <th>备注</th>
            </tr>
            <tr>
              <td align="center" rowspan="4">
                <div class="">深圳--全国</div>
                <div class="">例外航线除外</div>
              </td>
              <td align="center">J（公务舱）</td>
              <td align="center">15%</td>
              <td align="center" rowspan="4">单去、单回</td>
            </tr>
            <tr>
              <td align="center">Y（经济舱）</td>
              <td align="center">10%</td>
            </tr>
            <tr>
              <td align="center">B/M/U/H/Q（经济舱）</td>
              <td align="center">7%</td>
            </tr>
            <tr>
              <td align="center">V/W/S 经济舱</td>
              <td align="center">5%</td>
            </tr>
          </table>
          <div class="row">备注：</div>
          <div class="row">① 特价机票不再享受以上折上折优惠；</div>
          <div class="end-row">② 例外航线详情可咨询订票热线。</div>
          
          <div class="row text-bold">3、订票方式</div>
          <div class="row">● 深圳航空指定优质服务商—深圳市优行商旅科技有限公司 24小时订票服务热线：400 666 3232、0755-36861999，专属客户经理：0755-26585191。</div>
          <div class="end-row">报“2025深圳家居设计周”专属热线提供机票查询、预定、改期、退票、出票服务。</div>
          
          <div class="row">※ 注意 Notice：</div>
          <div class="end-row">机票退改签：按照实际承运折扣退改签规则为准</div>
          
          <div class="row text-bold">二、非展期优惠政策: </div>
          <div class="row">贵司成为深航大客户（需与深航签订大客户协议），可以享受以下权益（合同签订起一年内，具体优惠时间以企业签订的大客户协议为准）：</div>
          <div class="row"><span class="text-bold">1.机票优惠：</span>通过有资质的服务商（可以是企业自己合作的专属订票服务机构）订购深航，国航机票可以享受折上折优惠，一般优惠幅度在5-10%（具体折扣以最终订票价格为准）；</div>
          <div class="row"><span class="text-bold">2.领导保障：</span>重要领导可以备案深航贵宾，免费享受深航高端服务（名额配置根据企业年度采购量而定）；</div>
          <div class="row"><span class="text-bold">3.员工福利：</span>企业员工通过深航APP认证，可以享受因私购票优惠7-8%，优先参加凤凰知音会员快速升级活动（具体操作深航工作人员将与企业对接人联系）。</div>
          <div class="end-row">如需办理以上权益，可联系深航专属客户经理：<span class="text-bold">田经理 13714034033</span></div>
          
        </div> 

      </div> -->
      
      <div style="text-align: center;width: 100%;height: auto;position: relative;">
         <img src="https://exhoss41.szcwexpo.com/applet/20251216/20251216151701_4596_71.jpg" alt="超值酒店" class="title-img">
         <button class="button1" style="" @click="toHotal">酒店预订</button>
        
      </div>
     
      <div ref="hotel" class="section"></div>
     
    </div>
    
    <custom-footer :friendLink="friendLink"></custom-footer>
    
    <!-- 回到顶部 -->
    <scroll-top @scrollTop="scrollTop"></scroll-top>
    
  </div>
</template>

<script>
import { Swipe, SwipeItem, Icon } from 'vant';
import customHeader from "./components/head.vue";
import customFooter from "./components/foot.vue";
import scrollTop from "./components/scrollTop.vue";
import commonMixin from './commonMixin.js';
 
export default {
  // name: '展会介绍',
  components: {
    'custom-header': customHeader,
    'custom-footer': customFooter, 'scroll-top': scrollTop,
    [Icon.name]: Icon,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  mixins: [commonMixin],
  metaInfo: {
    // title: 'My Example App', // set a title
    meta: [
      { name: 'keyWords', content: '深圳家具展，家具展，家居设计，家具展商，家居论坛，设计周，家居设计周' },
      { name: 'description', content: '第42届深圳国际家具展暨深圳家居设计周，将于2027年3月15-17日在深圳国际会展中心盛大启幕，是目前国内唯一横向打通住宅、建筑、室内、家具、软装、灯光及工作环境全产业链的产业创新与教育分享展。' },
    ],
  },
  data() {
    return {
      current: 'traffic',
    }
  },
  created() {

  },
  methods: {
    tabChange(current) {
      console.log(current);
      this.current = current;
    },
    toHotal() {
      window.open('http://www.miceclouds.com/bookingquery.htm?id=2701', '_blank')
    }
  }
}
</script>

<style scoped lang="less">

// 移动端
@media screen and (max-width: 1023px) {
  .banner-container {
    width: 100%;
    
    .banner {
      width: 100%;
      height: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
  }
  .content-container {
    width: 375px;
    margin: 0 auto 20px;
    
    .tab {
      width: 110px;
      box-sizing: border-box;
      margin: 7px;
      padding: 5px;
      font-size: 14px;
      cursor: pointer;
      border-radius: 6px;
      
      .tab-icon {
        width: 100%;
        height: auto;
        background-color: #efefef;
        margin-bottom: 5px;
        border-radius: 4px;
        overflow: hidden;
      }
      
      &.active {
        box-shadow: 0 2px 10px rgba(0, 0, 0, .2);
      }
    }
    
    .title-img {
      display: block;
      width: 100%;
      height: auto;
    }
    
    .section {
      width: 375px;
      margin: 0 auto 20px;
      padding: 10px;
      font-size: 14px;
      
      h2 {
        margin: 30px 0 10px;
        font-size: 18px;
      }
      .tips {
        margin: 10px 0 30px;
      }
      
      .row {
        margin: 5px 0;
      }
      .end-row {
        margin-bottom: 15px;
      }
      
    }
    
    .t-log1 {
      width: 60px;
      height: auto;
      margin-right: 20px;
    }
    .t-log2 {
      width: 100px;
      height: auto;
      margin-top: 3px;
    }
    .t-log3 {
      width: 80px;
      height: auto;
      margin-right: 20px;
    }
    .t-log4 {
      width: 60px;
      height: auto;
    }
    .t-log5 {
      width: 172px;
      height: auto;
    }
    
    .price-table {
      width: 100%;
      height: auto;
    }
    .by-applet {
      width: 150px;
      height: auto;
    }
    
    .trip-qrcode {
      width: 160px;
      height: auto;
    }
    
  }
  
  .table {
    font-size: 12px;
    border: 1px solid #eee;
    display: table;
     
    th,td {
      display: table-cell;
      border: 1px solid #eee;
    }
  }

  .button1 {
    position:absolute;
    bottom: 21%;
    left: 20%;
    cursor: pointer;
    margin-top: 5px;
    position: absolute;
    background: #00ABA5;
    border-radius: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 2px 6px;
    color: white;
    color: rgb(255, 255, 255);
    font-family:'Microsoft YaHei';
    font-size: 5px;
    font-weight: bold;
    line-height: 7px;
    letter-spacing: 0%;
    text-align: left;
    border: 0px;
  }

}

@media screen and (min-width: 1024px) {
  
  .banner-container {
    width: 100%;
    
    .banner {
      width: 100%;
      height: 100%;
      background-position: center;
      background-repeat: no-repeat;
      background-size: 100% auto;
    }
  }
  .content-container {
    width: 270px;
    margin: 0 auto 20px;
    
    .tab {
      width: 33%;
      box-sizing: border-box;
      margin: 6px;
      padding: 4px;
      font-size: 5.4px;
      cursor: pointer;
      border-radius: 2px;
      
      .tab-icon {
        width: 100%;
        height: 50px;
        background-color: #efefef;
        margin-bottom: 4px;
        border-radius: 2px;
        overflow: hidden;
      }
      
      &.active,
      &:hover {
        box-shadow: 0 1px 5px rgba(0, 0, 0, .2);
      }
    }
    
    .title-img {
      display: block;
      width: 100%;
      height: auto;
      border-radius: 1px;
    }
    .section {
      width: 240px;
      margin: 0 auto 20px;
      padding: 10px;
      font-size: 3.3px;
      
      h2 {
        margin-top: 10px;
      }
      .tips {
        margin-bottom: 10px;
      }
      
      .row {
        margin-bottom: 1px;
      }
      .end-row {
        margin-bottom: 4px;
      }
      
    }
    
    .t-log1 {
      width: 12px;
      height: auto;
      margin-right: 3px;
      margin-top: 3px;
    }
    .t-log2 {
      width: 20px;
      height: auto;
      margin-top: 3px;
    }
    .t-log3 {
      width: 16px;
      height: auto;
      margin-right: 3px;
      margin-top: 3px;
    }
    .t-log4 {
      width: 12px;
      height: auto;
      margin-top: 3px;
    }
    .t-log5 {
      width: 60px;
      height: auto;
      margin-top: 3px;
    }
    
    .price-table {
      width: 100%;
      height: auto;
    }
    .by-applet {
      width: 30%;
      height: auto;
    }
    
    .trip-qrcode {
      width: 40px;
      height: auto;
    }
    
    .hotel {
      display: block;
      width: 60%;
      margin: 0 auto;
    }
    
  }
  
  .table {
    font-size: 3.2px;
    border: 0.1px solid #eee;
    display: table;
     
    th,td {
      display: table-cell;
      border: 0.1px solid #eee;
    }
  }

  
  .button1 {
    position:absolute;bottom: 21%;left: 19.5%;
    cursor: pointer;
    margin-top: 5px;
    position: absolute;
    background: #00ABA5;
    border-radius: 40px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding: 2px 6px;
    color: white;
    color: rgb(255, 255, 255);
    font-family:'Microsoft YaHei';
    font-size: 4px;
    font-weight: bold;
    line-height: 5px;
    letter-spacing: 0%;
    text-align: left;
    border: 0px;
  }
}

</style>